import { Component, Input, } from "@angular/core";
import { Deck } from "@apiserver-rest/ponder-data-client-base";
import { DeckPreviewComponent } from "./deck-preview.component";
import { UserDecksComponent } from "../user-decks.component";
import { NgClass } from "@angular/common";
import { Subscription } from "rxjs";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "deck-preview-group",
    imports: [NgClass, DeckPreviewComponent],
    templateUrl: "./deck-preview-group.component.html"
})
export class DeckPreviewGroupComponent {
    @Input({ required: true }) public userDeckComponentRef!: UserDecksComponent;
    @Input({ required: true }) public name!: string;
    @Input({ required: true }) public decks: Deck[] = [];

    public isVisible: boolean = true;

    private deckPreviewRefs: DeckPreviewComponent[] = []
    private deckDeletedSub!: Subscription;

    public constructor(events: EventBroker) {
        this.deckDeletedSub = events.deck.deckDeletedEvent.subscribe({
            next: (deckId: string) => {
                this.onDeckDeleted(deckId);
            }
        });
    }

    public ngOnDestroy(): void {
        this.deckDeletedSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.userDeckComponentRef.trackGroupComponent(this);
        this.sortDecks();
    }
    
    public trackPreviewRef(ref: DeckPreviewComponent): void {
        this.deckPreviewRefs.push(ref);
    }

    public untrackPreviewRef(ref: DeckPreviewComponent): void {
        var index = this.deckPreviewRefs.findIndex(r => r.deck.id == ref.deck.id);

        if (index >= 0) {
            this.deckPreviewRefs.splice(index, 1);
        }
    }

    public updateDeckVisibility(parent: UserDecksComponent): void {
        var visibleCount: number = 0;

        this.deckPreviewRefs.forEach(p => {
            if (parent.isDeckVisible(p.deck)) {
                p.isVisible = true;
                visibleCount++;
            } else {
                p.isVisible = false;
            }
        });

        this.isVisible = visibleCount > 0 ? true : false;
    }

    public sortDecks(): void {
        this.decks.sort((a, b) => (a.name! < b.name! ? -1 : 1));
    }

    public onNameChange(input: HTMLInputElement): void {
        this.userDeckComponentRef.changeGroupName(this.name, input.value);
    }

    private onDeckDeleted(deckId: string): void {
        var index = this.decks.findIndex(d => d.id === deckId);

        if (index >= 0) {
            console.log(`found at ${index}`)
            this.decks.splice(index, 1);
        }
    }
}